var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-tit-wrap-default', _vm._b({
    staticClass: "tit-wrap--lg text-center"
  }, 'u-tit-wrap-default', _vm.$attrs, false), [_c('u-tit-default', {
    staticClass: "tit--lg break-keep",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._t("default")], 2), this.$slots['TxtAdd'] ? _c('u-txt-default', {
    staticClass: "txt--dark font-weight-medium line-height-15",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._t("TxtAdd")], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }